import { gql } from '@apollo/client';

export default gql`
  fragment TaskTemplateFragment on TaskTemplate {
    __typename
    id
    title
    details
    instructions
    referencePhotos {
      id
      url
      thumbnailUrl
    }
    photoCaptureRequired
    subTaskTemplates {
      nodes {
        answerType
        answerOptions
        id
        label
        position
      }
    }
    taskListSectionTemplate {
      __typename
      title
      skippable
      id
    }
  }
`;
